import gql from 'graphql-tag';

export const CREATE_POST_MALONE_PROJECT_WITH_ARTICLE_BRIEF_MUTATION = gql`
  mutation CreatePostMaloneProjectWithArticleBriefMutation(
    $articleGroupId: ID!
    $articleBrief: PostMaloneProjectArticleBriefInput
  ) {
    createPostMaloneProjectForArticleGroup(articleGroupId: $articleGroupId, articleBrief: $articleBrief) {
      errors
    }
  }
`;
